<template>
  <div class="flex slide-in-on-top bg-gray-100 page" :class="{ 'oc-menu--open': openMenu }">
    <!--
      Sidebar
    -->
    <div class="oc-menu" :class="{ 'slide-in-on-top': true }">
      <slot name="sidebar" />
    </div>

    <!-- content push wrapper -->
    <div class="pusher">
      <slot :show-menu="showMenu" :hide-menu="hideMenu" />
      <div class="oc-overlay" @click="openMenu = !openMenu" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'OffCanvasLayout',
  data: () => ({
    openMenu: false,
  }),
  methods: {
    showMenu() {
      this.openMenu = true;
    },
    hideMenu() {
      this.openMenu = false;
    },
  },
};
</script>

<style lang="postcss" scoped>
.oc-menu {
  @apply absolute top-0 left-0 h-screen invisible z-50;
  transition: transform 0.25s;
}
.slide-in-on-top.oc-menu {
  @apply visible;
  transform: translateX(-100%);
}
.slide-in-on-top.oc-menu--open .slide-in-on-top.oc-menu {
  @apply visible;
  transform: translateX(0);
}
.slide-in-on-top.oc-menu::after {
  @apply hidden;
}
.pusher {
  @apply relative left-0 overflow-hidden h-screen;
  @apply flex-1;
  transition: transform 0.25s;
}
.oc-overlay {
  @apply absolute top-0 right-0 w-0 h-0 opacity-0;
  background-color: rgba(0, 0, 0, 0.2);
  content: ' ';
  transition: opacity 0.5s, width 0.1s 0.5s, height 0.1s 0.5s;
}
.oc-menu--open .oc-overlay {
  @apply w-full h-full opacity-100 z-40;
  transition: opacity 0.5s;
}

@screen lg {
  .slide-in-on-top.oc-menu {
    @apply visible;
    transform: translateX(0);
    @apply relative flex-none;
  }
  .pusher {
    /* // @apply pl-64; */
  }
  .oc-menu--open .oc-overlay {
    @apply hidden;
  }
}
</style>
